import { RedeemedCampaignTypeV2 } from '@/services/graphql/generated'
import { type ShopSession } from '@/services/shopSession/ShopSession.types'
import { includesYoungPetDiscount } from '@/utils/discounts.utils'

export const getDiscountsVisibility = (shopSession: ShopSession) => {
  const IS_CAMPAIGNS_ENABLED = shopSession.cart.campaignsEnabled

  const campaign = shopSession.cart.redeemedCampaignV2
  const campaignCode = campaign?.campaignCode

  const shouldShowToggle = IS_CAMPAIGNS_ENABLED
  const shouldShowDiscountForm = IS_CAMPAIGNS_ENABLED && !campaignCode
  const shouldShowDiscountSection =
    shouldShowDiscountSectionWithYoungPet(shopSession.cart) && (campaignCode || shouldShowDiscountForm)

  return {
    shouldShowToggle,
    shouldShowDiscountForm,
    shouldShowDiscountSection,
  }
}

export const shouldShowDiscountSectionWithYoungPet = (cart: ShopSession['cart']): boolean => {
  // Check if any item has YOUNG_PET discount
  const hasYoungPetDiscountItems = cart.items.some(({ productOffer }) => includesYoungPetDiscount(productOffer.cost))

  // If no YOUNG_PET discounts, always show the section
  if (!hasYoungPetDiscountItems) {
    return true
  }

  // If only one item with YOUNG_PET discount, hide the section
  if (cart.items.length === 1) {
    return false
  }

  // If there's a redeemed campaign, check its type and application
  if (cart.redeemedCampaignV2) {
    const { type, campaignCode } = cart.redeemedCampaignV2
    // Always show section for FOREVER (MONTHLY_COST) campaigns
    if (type === RedeemedCampaignTypeV2.Referral) {
      return true
    }

    // Hide section if redeemed campaign is not applied to any item
    // This prevents mixing YOUNG_PET with other pet campaigns
    return cart.items.some(({ productOffer }) => {
      const activeDiscountsCodes = productOffer.cost.discountsV2.map(({ itemDiscount }) => itemDiscount.campaignCode)
      return activeDiscountsCodes.includes(campaignCode)
    })
  }

  // If no campaign is redeemed, show the section
  return true
}
